import React from 'react';

var SVG1={
  stopColor: "#5ABD70"
}
var SVG2={
  stopColor: "#5A9F64"
}
var SVG3={
  stopColor: "#4D4D4D"
}
var SVG4={
  stopColor: "#000000"
}
var SVG5={
  stopColor: "#F2F2F2"
}
var SVG6={
  stopColor: "#CCCCCC"
}
var SVG7={
  stopColor: "#5ABD70"
}
var SVG8={
  stopColor: "#5A9F64"
}
var SVG9={
  stopColor: "#F0F0F0"
}
var SVG10={
  stopColor: "#E8E8E8"
}
var SVG11={
  stopColor: "#333333"
}
var SVG12={
  stopColor: "#4D4D4D"
}

const SVG=({
  style = {},
  fill = "#000",
  width = "100%",
  className = "",
  viewBox = "0 0 1366 768"
}) => (
  <svg width={width} style={style} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg" className={`svg-icon ${className || ""}`} xmlnsXlink="http://www.w3.org/1999/xlink">

  <path className="st0" d="M1289.5,247h-780c-5.2,0-9.5-4.3-9.5-9.5v-49c0-5.2,4.3-9.5,9.5-9.5h780c5.2,0,9.5,4.3,9.5,9.5v49
    C1299,242.7,1294.7,247,1289.5,247z"/>
  <path className="st1" d="M1289.5,372h-780c-5.2,0-9.5-4.3-9.5-9.5v-49c0-5.2,4.3-9.5,9.5-9.5h780c5.2,0,9.5,4.3,9.5,9.5v49
  	C1299,367.7,1294.7,372,1289.5,372z"/>
    <path className="st1" d="M1289.5,618h-780c-5.2,0-9.5-4.3-9.5-9.5v-173c0-5.2,4.3-9.5,9.5-9.5h780c5.2,0,9.5,4.3,9.5,9.5v173
      C1299,613.7,1294.7,618,1289.5,618z"/>
    <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="507" y1="85" x2="876" y2="85">
  		<stop  offset="0" style={SVG1}/>
  		<stop  offset="1" style={SVG2}/>
  	</linearGradient>
    <path fill={fill} d="M864,111H519c-6.6,0-12-5.4-12-12V71c0-6.6,5.4-12,12-12h345c6.6,0,12,5.4,12,12v28
  		C876,105.6,870.6,111,864,111z"/>
      <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="500" y1="155" x2="685" y2="155">
        <stop  offset="0" style={SVG3}/>
        <stop  offset="1" style={SVG4}/>
      </linearGradient>
      <path className="st3" d="M673,168H512c-6.6,0-12-5.4-12-12v-2c0-6.6,5.4-12,12-12h161c6.6,0,12,5.4,12,12v2
    		C685,162.6,679.6,168,673,168z"/>
        <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="500" y1="155" x2="685" y2="155">
      		<stop  offset="0" style={SVG3}/>
      		<stop  offset="1" style={SVG4}/>
      	</linearGradient>
    <path className="st4" d="M697,292H510c-6.6,0-12-5.4-12-12v-2c0-6.6,5.4-12,12-12h187c6.6,0,12,5.4,12,12v2
    		C709,286.6,703.6,292,697,292z"/>
        <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="498" y1="279" x2="709" y2="279">
          <stop  offset="0" style={SVG3}/>
          <stop  offset="1" style={SVG4}/>
        </linearGradient>
    <path className="st5" d="M712,415H510c-6.6,0-12-5.4-12-12v-2c0-6.6,5.4-12,12-12h202c6.6,0,12,5.4,12,12v2
    		C724,409.6,718.6,415,712,415z"/>


        <path className="st6 st" fill={fill} d="M419.4,0H370H20.6C9.2,0,0,9.2,0,20.6v726.8C0,758.8,9.2,768,20.6,768H370h49.4H440v-20.6V20.6V0H419.4z"/>
      	<text transform="matrix(1 0 0 1 63.0969 110.6035)" className="st7 st8 st9">Tranqui</text>
      	<linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="33" y1="168" x2="395" y2="168">
      		<stop  offset="0" style={SVG5}/>
      		<stop  offset="1" style={SVG6}/>
      	</linearGradient>
      	<path className="st10" d="M383,188H45c-6.6,0-12-5.4-12-12v-16c0-6.6,5.4-12,12-12h338c6.6,0,12,5.4,12,12v16
      		C395,182.6,389.6,188,383,188z"/>
      	<linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="1053" y1="685" x2="1299" y2="685">
      		<stop  offset="0" style={SVG7}/>
      		<stop  offset="1" style={SVG8}/>
      	</linearGradient>
      	<path fill={fill} d="M1287,718h-222c-6.6,0-12-5.4-12-12v-42c0-6.6,5.4-12,12-12h222c6.6,0,12,5.4,12,12v42
      		C1299,712.6,1293.6,718,1287,718z"/>
      	<linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="15" y1="704.1525" x2="425" y2="704.1525">
      		<stop  offset="0" style={SVG9}/>
      		<stop  offset="1" style={SVG10}/>
      	</linearGradient>
      	<path className="st12" d="M413,753.8H27c-6.6,0-12-5.4-12-12v-75.4c0-6.6,5.4-12,12-12h386c6.6,0,12,5.4,12,12v75.4
      		C425,748.4,419.6,753.8,413,753.8z"/>
      	<linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="33" y1="704.1525" x2="108" y2="704.1525">
      		<stop  offset="0" style={SVG11}/>
      		<stop  offset="1" style={SVG4}/>
      	</linearGradient>
      	<circle className="st13" cx="70.5" cy="704.2" r="37.5"/>
      	<linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="122" y1="690" x2="364" y2="690">
      		<stop  offset="0" style={SVG12}/>
      		<stop  offset="1" style={SVG4}/>
      	</linearGradient>
      	<path className="st14" d="M352,705H134c-6.6,0-12-5.4-12-12v-6c0-6.6,5.4-12,12-12h218c6.6,0,12,5.4,12,12v6
      		C364,699.6,358.6,705,352,705z"/>
      	<linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="122" y1="723" x2="266" y2="723">
      		<stop  offset="0" style={SVG12}/>
      		<stop  offset="1" style={SVG4}/>
      	</linearGradient>
      	<path className="st15" d="M259,732.5H129c-3.9,0-7-3.2-7-7v-5c0-3.9,3.1-7,7-7h130c3.9,0,7,3.1,7,7v5C266,729.3,262.9,732.5,259,732.5z
      		"/>

  </svg>
);

export default SVG;
